export default __webpack_public_path__ + "static/frac-909e1e45c7589e35f39e48ba6e7b2bc0.jpg";